import "./message.css.ts.vanilla.mjs";
var _ = "p273__message-5c96_fc8c0099d__lp7v6f0";
export {
  _ as messageStyle
};
//# sourceMappingURL=message.mjs.map
